// ROUSSA — Dots elegantes con pill deslizante (slide effect al mover imágenes)
(() => {
  const activeInstances = new WeakMap();

  function initSliderDots(scope) {
    const sliderComponent = scope.querySelector('slider-component[id*="GalleryViewer"]') ||
                           scope.querySelector('#GalleryViewer slider-component');
    if (!sliderComponent) return;
    if (activeInstances.has(sliderComponent)) return;
    activeInstances.set(sliderComponent, true);

    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const allSlides = Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]'));
    const dotsWrap = sliderComponent.querySelector('[data-dots-wrap]');
    const dots = Array.from(sliderComponent.querySelectorAll('.slider-counter__link--dots'));
    const pill = sliderComponent.querySelector('[data-dots-pill]');
    const track = sliderComponent.querySelector('.product-gallery-dots__track');

    if (!slider || allSlides.length < 2 || dots.length < 2) return;

    let sliderItemsToShow = [];
    let sliderItemOffset = 0;

    const calculateOffset = () => {
      sliderItemsToShow = Array.from(allSlides).filter((el) => el.clientWidth > 0);
      if (sliderItemsToShow.length < 2) {
        sliderItemOffset = sliderItemsToShow[0]?.clientWidth || 0;
        return;
      }
      sliderItemOffset = sliderItemsToShow[1].offsetLeft - sliderItemsToShow[0].offsetLeft;
      if (sliderItemOffset <= 0) sliderItemOffset = sliderItemsToShow[0].clientWidth;
    };

    const getActiveIndex = () => {
      if (sliderItemOffset === 0 || sliderItemsToShow.length === 0) {
        calculateOffset();
        if (sliderItemOffset === 0 || sliderItemsToShow.length === 0) return 0;
      }
      const currentPage = Math.round(slider.scrollLeft / sliderItemOffset) + 1;
      let activeIndex = currentPage - 1;
      if (activeIndex >= 0 && activeIndex < sliderItemsToShow.length) {
        const activeSlide = sliderItemsToShow[activeIndex];
        activeIndex = allSlides.indexOf(activeSlide);
        if (activeIndex < 0) activeIndex = 0;
      } else {
        const sliderRect = slider.getBoundingClientRect();
        let best = 0, bestV = 0;
        allSlides.forEach((slide, i) => {
          const r = slide.getBoundingClientRect();
          const v = (Math.min(r.right, sliderRect.right) - Math.max(r.left, sliderRect.left)) / Math.max(r.width, 1);
          if (v > bestV) { bestV = v; best = i; }
        });
        activeIndex = best;
      }
      return Math.max(0, Math.min(activeIndex, allSlides.length - 1));
    };

    const n = dots.length;
    let lastActiveIndex = -1;

    const updatePillAndDots = () => {
      calculateOffset();
      const scrollWidth = slider.scrollWidth - slider.clientWidth;
      const progress = scrollWidth <= 0 ? 0 : Math.min(Math.max(slider.scrollLeft / scrollWidth, 0), 1);
      const activeIndex = getActiveIndex();

      if (pill && track && dotsWrap) {
        const tw = track.offsetWidth;
        const pw = Math.max(12, Math.min(20, Math.floor(tw / n) - 4));
        const maxLeft = Math.max(tw - pw, 0);
        const left = progress * maxLeft;
        pill.style.width = pw + 'px';
        pill.style.transform = 'translate(' + left + 'px, -50%)';
      }

      if (activeIndex !== lastActiveIndex) {
        lastActiveIndex = activeIndex;
        dots.forEach((d, i) => {
          const active = i === activeIndex;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        calculateOffset();
        if (i < allSlides.length) {
          const targetSlide = allSlides[i];
          slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
        lastActiveIndex = -1;
        setTimeout(updatePillAndDots, 50);
      });
    });

    let rafId;
    const tick = () => {
      updatePillAndDots();
      rafId = requestAnimationFrame(tick);
    };
    tick();

    slider.addEventListener('scroll', () => updatePillAndDots(), { passive: true });

    const resizeObserver = new ResizeObserver(() => updatePillAndDots());
    resizeObserver.observe(slider);
    if (dotsWrap) resizeObserver.observe(dotsWrap);

    setTimeout(updatePillAndDots, 100);

    const cleanup = () => {
      if (rafId) cancelAnimationFrame(rafId);
      resizeObserver.disconnect();
      activeInstances.delete(sliderComponent);
    };
    sliderComponent._roussaDotsCleanup = cleanup;
  }

  function boot() {
    // Limpiar instancias anteriores
    document.querySelectorAll('slider-component[id*="GalleryViewer"]').forEach(comp => {
      if (comp._roussaDotsCleanup) {
        comp._roussaDotsCleanup();
      }
    });
    
    initSliderDots(document);
  }

  // carga normal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // por si Shopify re-renderiza por variantes
  document.addEventListener('shopify:section:load', () => {
    setTimeout(boot, 200);
  });
  
  // También escuchar cuando se carga el media gallery
  document.addEventListener('shopify:section:select', () => {
    setTimeout(boot, 200);
  });
})();
